// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../images/Bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Authentication_authenticationBox__X5Aud {
  /* background-image:url('./../../images/login.jpg'); */
  /* background-image:url('./../../images/Bg.jpg');
   */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  height: 100vh;
  display: flex;
  align-items: center;
  /* justify-content: flex-end; */
  justify-content: center;
  /* padding-right: 15%; */
  /* margin-top: -5px !important; */

  background-repeat: no-repeat;
  background-size: cover;
}

.Authentication_newauthenticationBox__xJBpH {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.Authentication_newauthenticationBoxImageDiv__fbh15 {
  width: 75%;
  height: 100vh;
}
.Authentication_newauthenticationBoxImageDiv__fbh15 img{
  width: 100%;
  height: 100%;
}
.Authentication_newauthenticationBoxLoginDiv__Mx4T3 {
  /* width: 25%; */
  /* background-image:url('./../../images/login_bg.jpg'); */
  background: #FFFFFF;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding:0 48px;
  gap: 3rem;
}
.Authentication_loginText__3Qho5{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}
.Authentication_loginText__3Qho5 span{
 /* border: 2px solid #FF7827;
 line-height: 28px;
  */
 background: #FF7827;
 line-height: 35px;
 width: 2px;
}
.Authentication_loginText__3Qho5 p{
 color: #FF7827;
 font-weight: 700;
 font-size: 24px;
}
.Authentication_loginForm__4RErr{

}
.Authentication_loginHeading__MqhTA{
  font-weight: 600;
  font-size: 14px;
  line-height: 12px;
  color: red !important;
}
.Authentication_SingInForm__xcr9C {
  /* background-image:url('./../../images/Bg.jpg'); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100vh;
  display: flex;
  align-items: center;
  /* justify-content: flex-end; */
  justify-content: center;

  background-repeat: no-repeat;
  background-size: cover;
}
.Authentication_authFooter__Td\\+Il {
  display: flex;
  justify-content: flex-end;
  padding-right: 10%;
  background: trasparent;
  margin-top: -30px;
  color: rgb(255, 255, 255) !important;
}
.Authentication_favicon__bs\\+La {
  position: relative;
  top: 5px;
  margin-left: 10px;
}

/* Lock screen */
.Authentication_profileBox__8qR\\+7 {
  border-radius: 10px;
  position: relative;
}
.Authentication_header__vpynC {
  background: #eaedfb;
  border-radius: 10px 10px 0px 0px;
  padding: 30px 15px 50px;
  position: relative;
}
.Authentication_headerContent__mR1r8 {
  max-width: 300px;
  position: relative;
  z-index: 1;
}
.Authentication_header__vpynC h1 {
  margin: 0 0 10px;
  font-size: 18px;
  color: rgb(0, 0, 0) !important;
  font-weight: 500;
}
.Authentication_header__vpynC p {
  margin: 0;
  font-size: 14px;
  color: white !important;
}
.Authentication_textSize__ESORt {
  font-size: 14px !important;
}
.Authentication_header__vpynC img {
  position: absolute;
  bottom: 0;
  right: 0;
}

.Authentication_profileInfo__tzsQn {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
}
.Authentication_profileInfo__tzsQn img {
  width: 60px;
  height: 60px;
  border: 5px solid #fff;
  border-radius: 100%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.Authentication_profileInfo__tzsQn h3 {
  margin: 5px 0 0;
  font-size: 14px;
}

@media only screen and (max-width: 767px) {
  .Authentication_googleBtn__h8HJ\\+ {
    padding: 13px 15px 13px 40px;
    font-size: 12px;
    margin-right: 5px;
  }
  .Authentication_googleBtn__h8HJ\\+ img {
    left: 15px;
    top: 10px;
  }
  .Authentication_fbBtn__\\+Z9D1 {
    padding: 13px 15px 13px 40px;
    font-size: 12px;
    margin-left: 5px;
  }
  .Authentication_fbBtn__\\+Z9D1 img {
    left: 15px;
    top: 10px;
  }
}

/* For RTL Style */
[dir="rtl"] .Authentication_favicon__bs\\+La {
  margin-left: 0;
  margin-right: 10px;
}

/* googleBtn */
[dir="rtl"] .Authentication_googleBtn__h8HJ\\+ {
  margin-right: 0;
  margin-left: 7px;
  padding: 16px 55px 16px 25px;
}
[dir="rtl"] .Authentication_googleBtn__h8HJ\\+ img {
  left: auto;
  right: 25px;
  margin-right: 0;
  margin-left: 5px;
}

/* Facebook Btn */
[dir="rtl"] .Authentication_fbBtn__\\+Z9D1 {
  margin-left: 0;
  margin-right: 7px;
  padding: 16px 55px 16px 25px;
}
[dir="rtl"] .Authentication_fbBtn__\\+Z9D1 img {
  left: auto;
  right: 25px;
  margin-right: 0;
  margin-left: 5px;
}

/* or */
[dir="rtl"] .Authentication_or__6vxBc:before {
  left: auto;
  right: 0;
}

/* Lock screen */
[dir="rtl"] .Authentication_header__vpynC img {
  right: auto;
  left: 0;
}

/* For dark mode */
[class="dark"] .Authentication_or__6vxBc {
  color: white !important;
}
[class="dark"] .Authentication_or__6vxBc:before {
  background: var(--borderColor);
}
[class="dark"] .Authentication_or__6vxBc span {
  background-color: #000;
}

/* googleBtn */
[class="dark"] .Authentication_googleBtn__h8HJ\\+ {
  background: var(--colorBlack);
  border: 1px solid var(--colorBlack);
}

/* Lock screen */
[class="dark"] .Authentication_header__vpynC {
  background: #101010;
}

@media only screen and (max-width: 767px) {
  [dir="rtl"] .Authentication_googleBtn__h8HJ\\+ {
    margin-right: 0;
    margin-left: 5px;
  }
  [dir="rtl"] .Authentication_googleBtn__h8HJ\\+ img {
    left: auto;
    right: 15px;
    top: 14px;
  }
  [dir="rtl"] .Authentication_fbBtn__\\+Z9D1 {
    margin-left: 0;
    margin-right: 5px;
  }
  [dir="rtl"] .Authentication_fbBtn__\\+Z9D1 img {
    left: auto;
    right: 15px;
    top: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Authentication.module.css"],"names":[],"mappings":"AAAA;EACE,sDAAsD;EACtD;IACE;EACF,yDAA8C;;EAE9C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;;EAEjC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yDAAyD;EACzD,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;CACC;;GAEE;CACF,mBAAmB;CACnB,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;AACA;;AAEA;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,mDAAmD;EACnD,yDAA8C;EAC9C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;;EAEvB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,SAAS;EACX;AACF;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,OAAO;AACP;EACE,UAAU;EACV,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,OAAO;AACT;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":[".authenticationBox {\n  /* background-image:url('./../../images/login.jpg'); */\n  /* background-image:url('./../../images/Bg.jpg');\n   */\n  background-image: url(\"./../../images/Bg.jpg\");\n\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  /* justify-content: flex-end; */\n  justify-content: center;\n  /* padding-right: 15%; */\n  /* margin-top: -5px !important; */\n\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.newauthenticationBox {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n.newauthenticationBoxImageDiv {\n  width: 75%;\n  height: 100vh;\n}\n.newauthenticationBoxImageDiv img{\n  width: 100%;\n  height: 100%;\n}\n.newauthenticationBoxLoginDiv {\n  /* width: 25%; */\n  /* background-image:url('./../../images/login_bg.jpg'); */\n  background: #FFFFFF;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding:0 48px;\n  gap: 3rem;\n}\n.loginText{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n.loginText span{\n /* border: 2px solid #FF7827;\n line-height: 28px;\n  */\n background: #FF7827;\n line-height: 35px;\n width: 2px;\n}\n.loginText p{\n color: #FF7827;\n font-weight: 700;\n font-size: 24px;\n}\n.loginForm{\n\n}\n.loginHeading{\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 12px;\n  color: red !important;\n}\n.SingInForm {\n  /* background-image:url('./../../images/Bg.jpg'); */\n  background-image: url(\"./../../images/Bg.jpg\");\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  /* justify-content: flex-end; */\n  justify-content: center;\n\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.authFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 10%;\n  background: trasparent;\n  margin-top: -30px;\n  color: rgb(255, 255, 255) !important;\n}\n.favicon {\n  position: relative;\n  top: 5px;\n  margin-left: 10px;\n}\n\n/* Lock screen */\n.profileBox {\n  border-radius: 10px;\n  position: relative;\n}\n.header {\n  background: #eaedfb;\n  border-radius: 10px 10px 0px 0px;\n  padding: 30px 15px 50px;\n  position: relative;\n}\n.headerContent {\n  max-width: 300px;\n  position: relative;\n  z-index: 1;\n}\n.header h1 {\n  margin: 0 0 10px;\n  font-size: 18px;\n  color: rgb(0, 0, 0) !important;\n  font-weight: 500;\n}\n.header p {\n  margin: 0;\n  font-size: 14px;\n  color: white !important;\n}\n.textSize {\n  font-size: 14px !important;\n}\n.header img {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.profileInfo {\n  position: relative;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.profileInfo img {\n  width: 60px;\n  height: 60px;\n  border: 5px solid #fff;\n  border-radius: 100%;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n}\n.profileInfo h3 {\n  margin: 5px 0 0;\n  font-size: 14px;\n}\n\n@media only screen and (max-width: 767px) {\n  .googleBtn {\n    padding: 13px 15px 13px 40px;\n    font-size: 12px;\n    margin-right: 5px;\n  }\n  .googleBtn img {\n    left: 15px;\n    top: 10px;\n  }\n  .fbBtn {\n    padding: 13px 15px 13px 40px;\n    font-size: 12px;\n    margin-left: 5px;\n  }\n  .fbBtn img {\n    left: 15px;\n    top: 10px;\n  }\n}\n\n/* For RTL Style */\n[dir=\"rtl\"] .favicon {\n  margin-left: 0;\n  margin-right: 10px;\n}\n\n/* googleBtn */\n[dir=\"rtl\"] .googleBtn {\n  margin-right: 0;\n  margin-left: 7px;\n  padding: 16px 55px 16px 25px;\n}\n[dir=\"rtl\"] .googleBtn img {\n  left: auto;\n  right: 25px;\n  margin-right: 0;\n  margin-left: 5px;\n}\n\n/* Facebook Btn */\n[dir=\"rtl\"] .fbBtn {\n  margin-left: 0;\n  margin-right: 7px;\n  padding: 16px 55px 16px 25px;\n}\n[dir=\"rtl\"] .fbBtn img {\n  left: auto;\n  right: 25px;\n  margin-right: 0;\n  margin-left: 5px;\n}\n\n/* or */\n[dir=\"rtl\"] .or:before {\n  left: auto;\n  right: 0;\n}\n\n/* Lock screen */\n[dir=\"rtl\"] .header img {\n  right: auto;\n  left: 0;\n}\n\n/* For dark mode */\n[class=\"dark\"] .or {\n  color: white !important;\n}\n[class=\"dark\"] .or:before {\n  background: var(--borderColor);\n}\n[class=\"dark\"] .or span {\n  background-color: #000;\n}\n\n/* googleBtn */\n[class=\"dark\"] .googleBtn {\n  background: var(--colorBlack);\n  border: 1px solid var(--colorBlack);\n}\n\n/* Lock screen */\n[class=\"dark\"] .header {\n  background: #101010;\n}\n\n@media only screen and (max-width: 767px) {\n  [dir=\"rtl\"] .googleBtn {\n    margin-right: 0;\n    margin-left: 5px;\n  }\n  [dir=\"rtl\"] .googleBtn img {\n    left: auto;\n    right: 15px;\n    top: 14px;\n  }\n  [dir=\"rtl\"] .fbBtn {\n    margin-left: 0;\n    margin-right: 5px;\n  }\n  [dir=\"rtl\"] .fbBtn img {\n    left: auto;\n    right: 15px;\n    top: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"authenticationBox": `Authentication_authenticationBox__X5Aud`,
	"newauthenticationBox": `Authentication_newauthenticationBox__xJBpH`,
	"newauthenticationBoxImageDiv": `Authentication_newauthenticationBoxImageDiv__fbh15`,
	"newauthenticationBoxLoginDiv": `Authentication_newauthenticationBoxLoginDiv__Mx4T3`,
	"loginText": `Authentication_loginText__3Qho5`,
	"loginForm": `Authentication_loginForm__4RErr`,
	"loginHeading": `Authentication_loginHeading__MqhTA`,
	"SingInForm": `Authentication_SingInForm__xcr9C`,
	"authFooter": `Authentication_authFooter__Td+Il`,
	"favicon": `Authentication_favicon__bs+La`,
	"profileBox": `Authentication_profileBox__8qR+7`,
	"header": `Authentication_header__vpynC`,
	"headerContent": `Authentication_headerContent__mR1r8`,
	"textSize": `Authentication_textSize__ESORt`,
	"profileInfo": `Authentication_profileInfo__tzsQn`,
	"googleBtn": `Authentication_googleBtn__h8HJ+`,
	"fbBtn": `Authentication_fbBtn__+Z9D1`,
	"or": `Authentication_or__6vxBc`
};
export default ___CSS_LOADER_EXPORT___;
